import clientWorkIsDone from "../../state/tasks";
import { ControlsAreSynchronized } from "../../widgets/ControlLibrary";

export default async function onSynchronized(): Promise<void> {
	await ControlsAreSynchronized();
	await clientWorkIsDone();
}
